var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('div',[_vm._t("default")],2),_vm._v(" "),(_vm.schemas.length)?_c('field-visiblity-settings',{attrs:{"schemas":_vm.schemas,"schemas-fields":_vm.fields,"selected-schemas-fields":_vm.selectedFields},on:{"change":function($event){return _vm.$emit('set:fields', $event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }